import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { ListItemIcon, MenuItem } from '@mui/material';
import { FC } from 'react';

type SubroutineCopyMenuItemProps = {
  type: 'subroutine' | 'folder';
  onSubmit: () => void;
};

const SubroutineCopyMenuItem: FC<SubroutineCopyMenuItemProps> = (props) => {
  return (
    <MenuItem onClick={(e) => props.onSubmit()}>
      <ListItemIcon>
        <ContentCopyIcon fontSize='small' />
      </ListItemIcon>
      Copy {props.type}
    </MenuItem>
  );
};

export default SubroutineCopyMenuItem;
